export default __webpack_public_path__ + "static/media/medicare-green-guided.33efb9e3.png";